import useToggleDetailOverlay from './useToggleDetailOverlay';
import { getVodItemGuid } from '../features/detail-overlay/utils/detailOverlayUtils';

const useDetailOverlay = () => {
    const { showDetailOverlay, removeSearchParams } = useToggleDetailOverlay();

    const openDetailOverlay = (item) => {
        removeSearchParams(['movie', 'series', 'guid', 'season']);
        const typeKey = item.programType === 'movie' ? 'movie' : 'series';
        showDetailOverlay({
            [typeKey]: btoa(item?.Id || ''),
            guid: btoa(getVodItemGuid(item)),
            season: btoa(item?.tvSeasonNumber || item?.seasonNumber || null),
        });
    };

    return openDetailOverlay;
};

export default useDetailOverlay;
